import { Box, Flex } from '@volue/wave-react';
import React from 'react';

export function GridVersionSection({
  gridVersionName
}: {
  gridVersionName: string;
}) {
  return (
    <>
      <Box css={{ color: '$colorAccent70', fontWeight: 'bolder ' }}>
        {'ArcGIS version'}
      </Box>
      <Flex>{gridVersionName}</Flex>
    </>
  );
}
